import React from 'react'
import Page from '../page'

import TeamPage from '../components/team/team'
import SEO from '../components/seo'

class Component extends Page {
  onMountGlobalState(state) {
    return {
      ...state,
      whiteLogo: true,
    }
  }

  render() {
    return [
      <SEO
        {...this.props.data.teampage}
        {...this.props.pathContext}
        key="seo"
      />,
      <TeamPage data={this.props.data} key="page" />,
    ]
  }
}

export default Component

export const pageQuery = graphql`
  query TeamPageQuerya($id: String!) {
    teampage: wordpressPage(id: { eq: $id }) {
      slug
      title
      t: title
      contentAst
      excerpt
      featured_media {
        localFile {
          childImageSharp {
            bgColor
            sizes(maxWidth: 1870, traceSVG: { color: "#821749" }) {
              ...GatsbyImageSharpSizes_withWebp_noBase64
            }
            ...SEOImageFragment
          }
        }
      }
      yoast {
        title
        metadesc
      }
      acf {
        show_featured_image
        show_header_spacer
        team_tiles_page {
          name
          title
          opisAst
          respImage {
            bgColor
            aspectRatio
            src
            srcSet
            srcWebp
            srcSetWebp
            sizes
          }
          path
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/page-team.js